import { Row } from "@commonlibs";
import styled, { css } from "styled-components";

export const KpisRoot = styled(Row)(
    ({ theme }) => css`
        background: ${theme.palette.gray["50"]};
        justify-content: space-between;
        row-gap: ${theme.spacing[4]};
        column-gap: ${theme.spacing[4]};
        flex-wrap: wrap;
        padding: ${theme.spacing[5]};
    `,
);
